import React from "react";
// old
// import ReactDOM from "react-dom";
// new
import { createRoot } from 'react-dom/client';

import reportWebVitals from "./reportWebVitals";
import App from "./App";

import dayjs from "dayjs";
import "./i18n";

import WeekDay from "dayjs/plugin/weekday";
import LocaleData from "dayjs/plugin/localeData";
import LocalizedFormat from "dayjs/plugin/localizedFormat";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

dayjs.extend(WeekDay);
dayjs.extend(LocaleData);
dayjs.extend(LocalizedFormat);

Sentry.init({
  dsn: "https://d39658781fdb456cb1d9eae8ce137adf@o1431966.ingest.sentry.io/4503908263919616",
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

// old
// ReactDOM.render(
//   <React.StrictMode>
//     <React.Suspense fallback="loading">
//       <App />
//     </React.Suspense>
//   </React.StrictMode>,
//   document.getElementById("root")
// );

// new
const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <React.Suspense fallback="loading">
      <App />
    </React.Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
